import React, { useRef, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import MemberImage from '~/assets/account/wework-member-login.png';
import { isEmpty } from '~/utils';
import Intl from '@fx-ui/intl';
import * as ww from '@wecom/jssdk';
import { Hyperlink } from '@fx-ui/jdy-design-biz';
import { accountStore } from '~/models';

// 企业微信登录
const WxWorkLogin: React.FunctionComponent = () => {
    const { memberConfig, memberUrl, adminUrl } = accountStore.wxWorkLoginConfig;

    const [wwCompAvailable, setWwCompAvailable] = useState(() => !isEmpty(memberConfig));
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setWwCompAvailable(!isEmpty(memberConfig));
    }, [memberConfig]);

    useEffect(() => {
        if (!wwCompAvailable || !containerRef.current || !memberConfig) {
            return;
        }

        const wwLogin = ww.createWWLoginPanel({
            el: containerRef.current,
            // @ts-ignore
            params: {
                ...memberConfig,
                redirect_uri: decodeURIComponent(memberConfig.redirect_uri),
                redirect_type: ww.WWLoginRedirectType.top
            },
            onLoginFail: () => {
                // 企微登录组件登录失败时，降级回扫码方案
                setWwCompAvailable(false);
            }
        });
        return () => {
            wwLogin.unmount();
        };
    }, [memberConfig, wwCompAvailable]);

    const renderMemberLogin = () => {
        if (wwCompAvailable) {
            return <div ref={containerRef} />;
        }
        return (
            <Hyperlink
                compact
                underline={false}
                target="_self"
                className="member-login-link"
                href={memberUrl}
            >
                <img className="login-image" src={MemberImage} alt="" />
                {Intl.get('account.signin.wework.member')}
            </Hyperlink>
        );
    };

    return (
        <div className="fx-wxwork-login">
            <div className="title">{Intl.get('account.signin.wework')}</div>
            <div className="member-login">{renderMemberLogin()}</div>
            <div className="auto-login-panel">
                <Hyperlink
                    compact
                    underline={false}
                    target="_self"
                    className="admin-login"
                    href={adminUrl}
                >
                    {Intl.get('account.signin.wework.admin')}
                </Hyperlink>
            </div>
        </div>
    );
};

export default observer(WxWorkLogin);
